import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  CreateContactModel,
  DeleteContactModel,
  EditContactModel,
  SearchContactModel,
} from '../../../models/contact.model'

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  private baseUrl = environment.baseUrl
  private resource: string = 'Contato'

  constructor(private httpClient: HttpClient) {}

  public createContact(
    model: CreateContactModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editContact(
    model: EditContactModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }

  public deleteContact(
    contactId: number,
    // model: any,
    // model: DeleteContactModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/remove/${contactId}`,
      {},
    )
  }

  public listPagedContact(
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedContactByPerson(
    idPerson: number,
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/pessoa/${idPerson}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listContact(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall`,
    )
  }

  public listContactByPerson(
    idPerson: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/list/pessoa/${idPerson}`,
    )
  }

  public searchContact(
    model: SearchContactModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search`,
      model,
    )
  }

  public getContactbyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedContact(
    page: number,
    rows: number = 15,
    model: SearchContactModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
